export const TOGGLE_SIDEBAR = `TOGGLE_SIDEBAR`
export const TOGGLE_LOADING = `TOGGLE_LOADING`
export const ADD_MENU_ITEM = `ADD_MENU_ITEM`
